/**
 * Converte uma string de cor hexadecimal para um formato RGBA.
 *
 * @param hex - A string hexadecimal (ex: "#FF0000", "#ff0", "ff0000").
 * @param alpha - O valor de opacidade (entre 0 e 1). O padrão é 1.
 * @returns A string da cor no formato rgba (ex: "rgba(255, 0, 0, 0.5)") ou null se o hex for inválido.
 */
export function hexToRgba(hex: string, alpha: number = 1): string | null {
  if (!hex || typeof hex !== "string") {
    return null;
  }

  let hexValue = hex.startsWith("#") ? hex.slice(1) : hex;

  if (hexValue.length === 3) {
    hexValue = hexValue
      .split("")
      .map((char) => char + char)
      .join("");
  }

  if (hexValue.length !== 6) {
    console.error("Formato hexadecimal inválido:", hex);
    return null;
  }

  const r = parseInt(hexValue.substring(0, 2), 16);
  const g = parseInt(hexValue.substring(2, 4), 16);
  const b = parseInt(hexValue.substring(4, 6), 16);

  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    console.error("Erro ao parsear valores hex:", hex);
    return null;
  }

  const validAlpha = Math.max(0, Math.min(1, alpha));

  return `rgba(${r}, ${g}, ${b}, ${validAlpha})`;
}
